import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppColor from "utilities/AppColor";
import { Box, Checkbox, Chip, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { SHIFT_COLOR } from "config/AppConfig";
import { Field, FieldArray } from "formik";
import SelectField from "components/Select/SelectField";
import { SHIFT } from "config/AppConfig";
import SelectTime from "components/Select/SelectTime";
import AppInput from "components/Input/AppInput";
import classNames from "classnames";
import AppButton from "components/CustomButtons/AppButton";
import { Label } from "reactstrap";
import { DAYS_OF_WEEK } from "config/AppConfig";
import SegmentFieldArray from "./SegmentFieldArray";
import ShiftTasksSection from "./ShiftTasksSection";
import AppUtil from "utilities/AppUtil";

const defaultWorkHistory = {
  isNew: true,
  shiftType: "",
  startTime: moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm"),
  endTime: moment(new Date())
    .add(1, "days")
    .hours(0)
    .minutes(0)
    .format("YYYY/MM/DD HH:mm"),
  numberWorkers: "",
  numberDayOfWeek: 0,
  isExpand: true,
  groupByDayOfWeek: {},
  segments: [],
};
// const COUNT_WEEK_DAY = {
//   'SUNDAY': 0,
//   'MONDAY': 1 ,
//   'TUESDAY': 2,
//   'WEDNESDAY': 3,
//   'THURSDAY':4 ,
//   'FRIDAY': 5,
//   'SATURDAY': 6
// }

const useStyles = makeStyles(() => ({
  wrapShift: {
    // border: "1px solid #c4b5bc",
    // boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
    padding: " 0 1rem 0.5rem 1rem",
    borderRadius: 4,
    marginBottom: "0.5rem",
    "& .shiftInfo": {
      // margin: "-1rem -1rem 1rem -1rem",
      padding: "0.3rem 1rem",
      border: "1px solid #c4b5bc",
      borderRadius: 4,
      backgroundColor: AppColor.white,
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      cursor: "pointer",
    },
    "& .shiftInfo.MORNING": {
      backgroundColor: SHIFT_COLOR.MORNING,
      color: "#fff",
    },
    "& .shiftInfo.AFTERNOON": {
      backgroundColor: SHIFT_COLOR.AFTERNOON,
      color: "#fff",
    },
    "& .shiftInfo.EVENING": {
      backgroundColor: SHIFT_COLOR.EVENING,
      color: "#fff",
    },
    "& .shiftInfo.NIGHT": {
      backgroundColor: SHIFT_COLOR.NIGHT,
      color: "#fff",
    },
    "& .remove-icon": {
      fontSize: "2rem",
      color: AppColor.red,
    },
  },
  collapseShift: {
    // border: "1px solid #c4b5bc",
    // boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 1rem",
    margin: "0.5rem 0",
    "& .shiftInfo": {
      margin: 0,
      padding: "0.3rem 1rem",
      border: "1px solid #c4b5bc",
      borderRadius: 4,
      backgroundColor: AppColor.white,
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      cursor: "pointer",
    },
    "& .shiftInfo.MORNING": {
      backgroundColor: SHIFT_COLOR.MORNING,
      color: "#fff",
    },
    "& .shiftInfo.AFTERNOON": {
      backgroundColor: SHIFT_COLOR.AFTERNOON,
      color: "#fff",
    },
    "& .shiftInfo.EVENING": {
      backgroundColor: SHIFT_COLOR.EVENING,
      color: "#fff",
    },
    "& .shiftInfo.NIGHT": {
      backgroundColor: SHIFT_COLOR.NIGHT,
      color: "#fff",
    },
    "& .remove-icon": {
      fontSize: "2rem",
      color: AppColor.red,
      paddingRight: "3px",
    },
  },
  deleteRight: {
    cursor: "pointer",
  },
  disabled: {
    opacity: 0.6,
    pointerEvents: "none",
  },
  jobAvailabilityRequest: {
    width: "100%",
    margin: "1rem 0",
    borderRadius: "5px",
    border: "1px dashed #c4b5bc",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
  },
  errorsShift: {
    width: "100%",
    margin: "1rem 0",
    borderRadius: "5px",
    border: "3px dashed #fe6359",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
  },
  jobAvailabilityRequestExpand: {
    width: "100%",
    margin: "1rem 0",
    borderRadius: "5px",
    border: "1px solid #c4b5bc",
    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
  },
  headerAvailabilityDayOfWeek: {
    display: "flex",
    width: `${100 / 7}%`,
    fontWeight: "bold",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 2px 4px 2px",
    backgroundColor: "#f1eeec",
  },
  bodyAvailabilityDayOfWeek: {
    display: "flex",
    width: `${100 / 7}%`,
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #e0e0e0",
    margin: "0 2px",
    backgroundColor: "#f8f8f8",
  },
  rootCheckBox: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  iconCheckBox: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    // "input:disabled ~ &": {
    //   boxShadow: "none",
    //   background: "#67a3c9",
    //   opacity: 0.6,
    // },
  },
  bookedIconCheckBox: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: AppColor.red,
      opacity: 0.6,
    },
  },
  checkedIconCheckBox: {
    backgroundColor: "#59d5b2",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      background: "#59d5b2",
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#59d57e",
    },
  },
  bookedCheckedIconCheckBox: {
    backgroundColor: AppColor.red,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#f39791",
    },
  },
  borderTopLeft: {
    borderTopLeftRadius: "10px",
  },
  borderTopRight: {
    borderTopRightRadius: "10px",
  },
  borderBottomLeft: {
    borderBottomLeftRadius: "10px",
  },
  borderBottomRight: {
    borderBottomRightRadius: "10px",
  },
  wrapSaveButton: {
    display: "flex",
    paddingTop: "0.5rem",
    justifyContent: "flex-start",
  },
  // segment
  segmentContainer: {
    padding: "10px",
    marginTop: "10px",
    borderRadius: "5px",
    border: "1px dashed #c4b5bc",
  },
}));

const JobAvailabilityFieldArray = (props) => {
  const isMobile = AppUtil.mobileAndTabletCheck();
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    jobId,
    formData,
    isLoading,
    handleCreateUpdateShift,
    handleChange,
    isSubmitting,
    setFieldValue,
    getNumberDayOfWeek,
    // setJobAvailabilityDelete,
    // isAllowRemoveAvailability,
    // setShowConfirmDeleteNextWeek,
    handleShowPopupDeleteShift,
    handleChangeDayOfWeek,
    initializeData,
    isAdd,
    isDisabled,
    errors,
  } = props;

  const { jobAvailabilityRequests = [] } = formData;
  const { jobAvailabilityRequests: jaRequestErrors = [] } = errors;

  const _handleSelectChangeStartTime = (
    index,
    endTime,
    event,
    formData,
    handleChange,
  ) => {
    const date = formData.startDate ? moment(formData.startDate) : moment();
    const newValues = { ...formData };
    if (index > -1) {
      event = moment(new Date(event)).set({
        year: date.get("year"),
        month: date.get("month"),
        date: date.get("date"),
      });
      const momentEndTime = moment(endTime);
      if (moment.range(event, momentEndTime).diff("minutes") <= 0) {
        momentEndTime.add(1, "days");
        newValues.jobAvailabilityRequests[index][
          "endTime"
        ] = momentEndTime.format("YYYY/MM/DD HH:mm");
      }
      newValues.jobAvailabilityRequests[index]["startTime"] = event.format(
        "YYYY/MM/DD HH:mm",
      );
      handleChange({
        target: {
          name: "jobAvailabilityRequests",
          value: newValues.jobAvailabilityRequests,
        },
      });
    }
  };
  const _handleSelectChangeEndTime = (
    index,
    startTime,
    event,
    formData,
    handleChange,
  ) => {
    const date = formData.startDate ? moment(formData.startDate) : moment();
    const newValues = { ...formData };
    if (index > -1) {
      event = moment(new Date(event)).set({
        year: date.get("year"),
        month: date.get("month"),
        date: date.get("date"),
      });
      const momentStartTime = moment(startTime);

      if (moment.range(momentStartTime, event).diff("minutes") <= 0) {
        event.add(1, "days");
      }
      newValues.jobAvailabilityRequests[index]["endTime"] = event.format(
        "YYYY/MM/DD HH:mm",
      );
      handleChange({
        target: {
          name: "jobAvailabilityRequests",
          value: newValues.jobAvailabilityRequests,
        },
      });
    }
  };
  const shiftConstructor = (item, startDate) => {
    const newStartTime =
      item.startTime || item.startTime !== ""
        ? moment(item.startTime).set({
            year: startDate.get("year"),
            month: startDate.get("month"),
            date: startDate.get("date"),
          })
        : null;
    const newEndTime =
      item.endTime || item.endTime !== ""
        ? moment(item.endTime).set({
            year: startDate.get("year"),
            month: startDate.get("month"),
            date: startDate.get("date"),
          })
        : null;

    if (newStartTime && newEndTime) {
      if (moment.range(newStartTime, newEndTime).diff("minutes") <= 0) {
        newEndTime.add(1, "days");
      }
    }
    return {
      ...item,
      startTime: newStartTime ? newStartTime.format("YYYY/MM/DD HH:mm") : null,
      endTime: newEndTime ? newEndTime.format("YYYY/MM/DD HH:mm") : null,
    };
  };

  const handleDeleteAvailability = (
    numberOfBooked,
    isAllowRemoveAvailability,
    isHasShiftId,
    groupByDayOfWeek,
    index,
    remove,
  ) => {
    // if (!isAllowRemoveAvailability || (!!numberOfBooked && numberOfBooked > 0)) {
    //   return null;
    // }
    if (isAllowRemoveAvailability) {
      if (isHasShiftId) {
        const ids = [];
        let isHasBooked = false;
        Object.keys(groupByDayOfWeek).forEach((key) => {
          if (groupByDayOfWeek[key].isBooked) {
            isHasBooked = true;
          }
          if (
            groupByDayOfWeek[key] &&
            (groupByDayOfWeek[key].id || groupByDayOfWeek[key].id === 0)
          ) {
            ids.push(groupByDayOfWeek[key].id);
          }
          if (
            groupByDayOfWeek[key] &&
            (groupByDayOfWeek[key].idNextWeek ||
              groupByDayOfWeek[key].idNextWeek === 0)
          ) {
            ids.push(groupByDayOfWeek[key].idNextWeek);
          }
        });
        handleShowPopupDeleteShift(ids, isHasBooked);
      } else {
        remove(index);
      }
    }
  };

  if (!formData || !jobAvailabilityRequests) {
    return null;
  }

  return (
    <FieldArray
      name="jobAvailabilityRequests"
      render={({ insert, remove }) => (
        <React.Fragment>
          <Box className="mb-3 mt-3">
            <AppButton
              className="btn btn-info mr-1"
              mode="outlined"
              buttonColor={AppColor.mainBlue}
              type="button"
              label={t("button.add")}
              onClick={() => {
                let numberDayOfWeek = 0;
                if (formData.startDate && formData.endDate) {
                  numberDayOfWeek = getNumberDayOfWeek({
                    startDate: formData.startDate,
                    endDate: formData.endDate,
                    dayOfWeekList: defaultWorkHistory.dayOfWeekList,
                  });
                }
                insert(jobAvailabilityRequests.length, {
                  ...defaultWorkHistory,
                  numberDayOfWeek,
                });
              }}
              disabled={isDisabled}
            >
              <i className="fas fa-plus"></i>
            </AppButton>
          </Box>
          {jobAvailabilityRequests &&
            jobAvailabilityRequests.map((item, index) => {
              const {
                // dayOfWeek,
                shiftType,
                shiftTypeNextWeek,
                startTime,
                endTime,
                isExpand,
                numberOfBooked = 0,
                totalBookings = 0,
                startTimeNextWeek,
                endTimeNextWeek,
                startTimeCurrentWeek,
                endTimeCurrentWeek,
                isApply,
                isNew,
                // isApplyNextWeek,
                countGroupShiftId,
                groupByDayOfWeek,
                settingNextWeek,
                numberOfStaffs,
              } = jobAvailabilityRequests[index];

              const activeIds = Object.keys(groupByDayOfWeek || {})
                .map((day) => groupByDayOfWeek[day])
                .filter(
                  (dayObj) =>
                    dayObj &&
                    dayObj.status === "ACTIVE" &&
                    dayObj.id !== undefined &&
                    dayObj.id !== null &&
                    dayObj.id !== ""
                )
                .map((dayObj) => dayObj.id);

              if (
                (!isApply && !isNew) ||
                (item.status && item.status === "INACTIVE")
              ) {
                return;
              }
              let isHasShiftId = false;
              let isAllowRemoveAvailability = true;
              const availabilitySameDay = [];
              const startDate = moment(formData.startDate);
              const endDate = moment(formData.endDate).hours(23).minutes(59);
              // const nextWeek = moment().add(7, 'days').hours(0).minutes(0);
              const nextDay = moment().add(1, "days").hours(0).minutes(0);
              // const sundayNextWeek = moment().add(1, 'weeks').isoWeekday(6).add(1, 'days').hours(23).minutes(59);
              // if next week is Final
              const isFinalWeek =
                moment.range(nextDay, endDate).diff("minutes") < 30;
              const currentShift = shiftConstructor(
                formData.jobAvailabilityRequests[index],
                startDate,
              );
              let isConflict;
              let countDayOfWeekActive = 0;
              for (let i = 0; i < jobAvailabilityRequests.length; i++) {
                // Get availabilitySameDay
                const jobAvailability = jobAvailabilityRequests[i];
                if (
                  i !== index &&
                  jobAvailability.shiftType === shiftType &&
                  jobAvailability.status !== "INACTIVE"
                ) {
                  // apply from current week to endDate
                  if (
                    jobAvailability.isApply ||
                    jobAvailability.isApplyNextWeek ||
                    jobAvailability.isNew
                  ) {
                    // case jobAvailability current has been deleted next week
                    // if (!jobAvailability.isApply && jobAvailability.isApplyNextWeek) {
                    //   const jobAvailabilityParent = formData.jobAvailabilityRequests.find(item => (item.id === jobAvailability.parentId))
                    //   if (jobAvailabilityParent) {
                    //     continue;
                    //   }
                    // }
                    // startTime and endTime apply
                    availabilitySameDay.push({
                      startTime: jobAvailability.startTimeCurrentWeek,
                      endTime: jobAvailability.endTimeCurrentWeek,
                      shiftType: jobAvailability.shiftType,
                    });
                    // case jobAvailability other apply for Next week
                    if (
                      jobAvailability.startTimeNextWeek !==
                        jobAvailability.startTimeCurrentWeek ||
                      jobAvailability.endTimeNextWeek !==
                        jobAvailability.endTimeCurrentWeek
                    ) {
                      availabilitySameDay.push({
                        startTime: jobAvailability.startTimeNextWeek,
                        endTime: jobAvailability.endTimeNextWeek,
                        shiftType: jobAvailability.shiftType,
                      });
                    }
                  }
                }
              }
              // Check isConflict for currentShift
              if (
                currentShift &&
                currentShift.startTime &&
                currentShift.endTime
              ) {
                for (const i in availabilitySameDay) {
                  if (
                    availabilitySameDay[i].startTime &&
                    availabilitySameDay[i].endTime &&
                    availabilitySameDay[i].startTime ===
                      currentShift.startTime &&
                    availabilitySameDay[i].endTime === currentShift.endTime
                  ) {
                    isConflict = true;
                    break;
                  }
                }
              }
              Object.keys(groupByDayOfWeek).forEach((day) => {
                if (
                  groupByDayOfWeek[day] &&
                  (groupByDayOfWeek[day].id || groupByDayOfWeek[day] === 0)
                ) {
                  isHasShiftId = true;
                }
                if (
                  groupByDayOfWeek[day] &&
                  groupByDayOfWeek[day].status === "ACTIVE"
                ) {
                  countDayOfWeekActive += 1;
                }
              });
              if (countGroupShiftId || countGroupShiftId === 0) {
                isAllowRemoveAvailability = countGroupShiftId > 1;
              }
              const isErrors =
                jaRequestErrors[index] &&
                Object.getOwnPropertyNames(jaRequestErrors[index]).length > 0
                  ? true
                  : false;

              return (
                <Box key={`ip-${index}`}>
                  <Grid
                    container
                    spacing={2}
                    className={
                      isExpand
                        ? classes.jobAvailabilityRequestExpand
                        : isErrors
                        ? classes.errorsShift
                        : classes.jobAvailabilityRequest
                    }
                  >
                    <Grid item xs={isMobile ? 12 : 6}>
                      <Box
                        key={`ip-${index}`}
                        className={
                          isExpand ? classes.wrapShift : classes.collapseShift
                        }
                      >
                        {!isExpand &&
                          jobAvailabilityRequests.length > 0 &&
                          !isDisabled && (
                            <Box className={"remove-icon"}>
                              <Box
                                onClick={() => {
                                  handleDeleteAvailability(
                                    numberOfBooked,
                                    isAllowRemoveAvailability,
                                    isHasShiftId,
                                    groupByDayOfWeek,
                                    index,
                                    remove,
                                  );
                                }}
                                className={classNames({
                                  [classes.deleteRight]: true,
                                  // [classes.disabled]: !isAllowRemoveAvailability || (!!numberOfBooked && numberOfBooked > 0),
                                })}
                                disabled={isDisabled}
                              >
                                <i className="far fa-times-circle"></i>
                              </Box>
                            </Box>
                          )}
                        <Box
                          className={`shiftInfo ${shiftType}`}
                          onClick={() => {
                            setFieldValue(
                              `jobAvailabilityRequests[${index}].isExpand`,
                              !isExpand,
                            );
                            const newGroupByDayOfWeek = {};
                            Object.keys(groupByDayOfWeek).forEach((day) => {
                              if (
                                groupByDayOfWeek[day].id ||
                                groupByDayOfWeek[day].id === 0
                              ) {
                                newGroupByDayOfWeek[day] =
                                  groupByDayOfWeek[day];
                                newGroupByDayOfWeek[day].status = "ACTIVE";
                              }
                            });
                            if (
                              Object.getOwnPropertyNames(newGroupByDayOfWeek)
                                .length === 0
                            ) {
                              setFieldValue(
                                `jobAvailabilityRequests[${index}].groupByDayOfWeek`,
                                groupByDayOfWeek,
                              );
                            } else {
                              setFieldValue(
                                `jobAvailabilityRequests[${index}].groupByDayOfWeek`,
                                newGroupByDayOfWeek,
                              );
                            }
                          }}
                        >
                          <span>
                            {`${shiftType ? t(`shift.${shiftType}`) : ""} ${
                              startTimeCurrentWeek
                                ? moment(startTimeCurrentWeek).format("HH:mm")
                                : startTime
                                ? moment(startTime).format("HH:mm")
                                : "00:00"
                            } 
                                  - 
                                  ${
                                    endTimeCurrentWeek
                                      ? moment(endTimeCurrentWeek).format(
                                          "HH:mm",
                                        )
                                      : endTime
                                      ? moment(endTime).format("HH:mm")
                                      : "00:00"
                                  }`}
                            {settingNextWeek && (
                              <span style={{ paddingLeft: "10px" }}>
                                (
                                {shiftTypeNextWeek &&
                                shiftTypeNextWeek !== shiftType
                                  ? t(
                                      "label.startTimeEndTimeShiftTypeNextWeek",
                                      {
                                        shiftType: t(
                                          `shift.${shiftTypeNextWeek}`,
                                        ),
                                        startTimeNextWeek: moment(
                                          startTimeNextWeek,
                                        ).format("HH:mm"),
                                        endTimeNextWeek: moment(
                                          endTimeNextWeek,
                                        ).format("HH:mm"),
                                      },
                                    )
                                  : t("label.startTimeEndTimeNextWeek", {
                                      startTimeNextWeek: moment(
                                        startTimeNextWeek,
                                      ).format("HH:mm"),
                                      endTimeNextWeek: moment(
                                        endTimeNextWeek,
                                      ).format("HH:mm"),
                                    })}
                                )
                              </span>
                            )}
                          </span>
                          <span>
                            <Chip
                              style={{
                                backgroundColor: AppColor.pink,
                                color: AppColor.white,
                              }}
                              size="small"
                              label={`${numberOfBooked}/${totalBookings}`}
                            />
                          </span>
                        </Box>
                        {isExpand && (
                          <React.Fragment>
                            {/* Shift Type */}
                            <Field
                              component={SelectField}
                              name={`jobAvailabilityRequests[${index}].shiftType`}
                              label={"label.shift"}
                              options={SHIFT.map((item) => {
                                return {
                                  value: item,
                                  label: t(`shift.${item}`),
                                };
                              })}
                              // disabled={!!((numberOfBooked && numberOfBooked > 0) || (settingNextWeek))}
                              // disabled={(!!numberOfBooked && numberOfBooked > 0)}
                              onSelected={(value) => {
                                const date = formData.startDate
                                  ? moment(formData.startDate)
                                  : moment();
                                const segmentsList =
                                  jobAvailabilityRequests[index].segments || [];
                                var isUpdateSegment = false;
                                // check shift type segment and shift type jobAvailability
                                for (let i = 0; i < segmentsList.length; i++) {
                                  if (segmentsList[i].shiftType === value) {
                                    isUpdateSegment = true;
                                    segmentsList[i].shiftType = "";
                                    segmentsList[i].startTime = "";
                                    segmentsList[i].endTime = "";
                                  }
                                }

                                if (
                                  jobAvailabilityRequests[index]
                                    .numberOfBooked === "" &&
                                  jobAvailabilityRequests[index]
                                    .numberOfBooked === 0
                                ) {
                                  setFieldValue(
                                    `jobAvailabilityRequests[${index}].startTime`,
                                    moment(date)
                                      .hours(0)
                                      .minutes(0)
                                      .format("YYYY/MM/DD HH:mm"),
                                  );
                                  setFieldValue(
                                    `jobAvailabilityRequests[${index}].endTime`,
                                    moment(date)
                                      .add(1, "days")
                                      .hours(0)
                                      .minutes(0)
                                      .format("YYYY/MM/DD HH:mm"),
                                  );
                                }
                                if (isUpdateSegment) {
                                  setFieldValue(
                                    `jobAvailabilityRequests[${index}].segments`,
                                    segmentsList,
                                  );
                                }
                              }}
                              required
                            />
                            {isConflict && (
                              <Label
                                className={`${classes.label}`}
                                style={{ color: AppColor.red }}
                              >
                                {t("validation.conflictTime")}
                              </Label>
                            )}
                            {/* Start Time End Time */}
                            <Field
                              component={SelectTime}
                              name={`jobAvailabilityRequests[${index}].startTime`}
                              onSelected={(event) =>
                                _handleSelectChangeStartTime(
                                  index,
                                  endTime,
                                  event,
                                  formData,
                                  handleChange,
                                )
                              }
                              label={"label.startTime"}
                              disabled={
                                !shiftType ||
                                shiftType === "" ||
                                (isFinalWeek &&
                                  numberOfBooked &&
                                  numberOfBooked > 0)
                              }
                              required
                            />
                            <Field
                              component={SelectTime}
                              name={`jobAvailabilityRequests[${index}].endTime`}
                              label={"label.endTime"}
                              onSelected={(event) =>
                                _handleSelectChangeEndTime(
                                  index,
                                  startTime,
                                  event,
                                  formData,
                                  handleChange,
                                )
                              }
                              disabled={
                                !shiftType ||
                                shiftType === "" ||
                                (isFinalWeek &&
                                  numberOfBooked &&
                                  numberOfBooked > 0)
                              }
                              required
                            />
                            {/* Number of staffs */}
                            <Field
                              component={AppInput}
                              name={`jobAvailabilityRequests[${index}].numberWorkers`}
                              label={"label.numberOfStaffs"}
                              type="number"
                              disabled={
                                !!(
                                  numberOfBooked &&
                                  numberOfBooked > 0 &&
                                  isFinalWeek
                                )
                              }
                              required
                            />
                            {/* segments */}
                            {isExpand && startTime && endTime && shiftType && (
                              <SegmentFieldArray
                                startDate={formData.startDate}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                jobAvailability={jobAvailabilityRequests[index]}
                                fieldArrayName={`jobAvailabilityRequests[${index}].segments`}
                                settingNextWeek={settingNextWeek}
                                minTime={moment(startTime)}
                                maxTime={moment(endTime)}
                                isDisabled={isDisabled}
                              />
                            )}
                            {!isAdd && (
                              <div className={classes.wrapSaveButton}>
                                <AppButton
                                  label={`${t("button.save")}`}
                                  rounder
                                  type={"button"}
                                  onClick={() => {
                                    if (countDayOfWeekActive > 0) {
                                      handleCreateUpdateShift({
                                        ...item,
                                        index,
                                      });
                                    }
                                  }}
                                  isLoading={isSubmitting || isLoading}
                                  disabled={
                                    isSubmitting ||
                                    isLoading ||
                                    isDisabled ||
                                    isConflict ||
                                    countDayOfWeekActive === 0 ||
                                    numberOfStaffs === 0
                                  }
                                />

                                <AppButton
                                  label={`${t("button.delete")}`}
                                  rounder
                                  className="ml-1"
                                  buttonColor={AppColor.pink}
                                  type={"button"}
                                  onClick={() => {
                                    handleDeleteAvailability(
                                      numberOfBooked,
                                      isAllowRemoveAvailability,
                                      isHasShiftId,
                                      groupByDayOfWeek,
                                      index,
                                      remove,
                                    );
                                  }}
                                  isLoading={isSubmitting || isLoading}
                                  // disabled={isSubmitting || isLoading || !isAllowRemoveAvailability || (!!numberOfBooked && numberOfBooked > 0)}
                                  disabled={
                                    isSubmitting || isLoading || isDisabled
                                  }
                                />
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={isMobile ? 12 : 6}>
                      <div style={{ display: "flex" }}>
                        {DAYS_OF_WEEK.map((day, index) => {
                          var className = `${classes.headerAvailabilityDayOfWeek}`;
                          if (index === 0) {
                            className += ` ${classes.borderTopLeft}`;
                          }
                          if (index + 1 === DAYS_OF_WEEK.length) {
                            className += ` ${classes.borderTopRight}`;
                          }
                          return (
                            <div
                              key={`day-of-week-${day}`}
                              className={className}
                            >
                              {t(`daysOfTheWeekAcronym.${day}`)}
                            </div>
                          );
                        })}
                      </div>
                      <div style={{ display: "flex" }}>
                        {DAYS_OF_WEEK.map((day, indexDay) => {
                          var className = `${classes.bodyAvailabilityDayOfWeek}`;
                          if (indexDay === 0) {
                            className += ` ${classes.borderBottomLeft}`;
                          }
                          if (indexDay + 1 === DAYS_OF_WEEK.length) {
                            className += ` ${classes.borderBottomRight}`;
                          }
                          const isBooked =
                            groupByDayOfWeek &&
                            groupByDayOfWeek[day] &&
                            groupByDayOfWeek[day].isBooked;
                          const isActive = !!(
                            groupByDayOfWeek &&
                            groupByDayOfWeek[day] &&
                            groupByDayOfWeek[day].status === "ACTIVE"
                          );
                          return (
                            <div
                              key={`day-of-week-${day}`}
                              className={className}
                            >
                              <Checkbox
                                className={classes.rootCheckBox}
                                disableRipple
                                color="default"
                                disabled={
                                  (countDayOfWeekActive <= 1 && isActive) ||
                                  isDisabled
                                }
                                checked={isActive}
                                checkedIcon={
                                  <span
                                    className={
                                      isBooked
                                        ? `${classes.bookedIconCheckBox} ${classes.bookedCheckedIconCheckBox}`
                                        : `${classes.iconCheckBox}  ${classes.checkedIconCheckBox}`
                                    }
                                  />
                                }
                                icon={
                                  <span
                                    className={
                                      isBooked
                                        ? classes.bookedIconCheckBox
                                        : classes.iconCheckBox
                                    }
                                  />
                                }
                                onChange={(event) => {
                                  if (!isSubmitting && !isLoading) {
                                    if (isHasShiftId && !isExpand) {
                                      if (event.target.checked) {
                                        handleChangeDayOfWeek(
                                          jobAvailabilityRequests[index],
                                          initializeData
                                            .jobAvailabilityRequests[index],
                                          day,
                                          true,
                                        );
                                      } else {
                                        handleChangeDayOfWeek(
                                          jobAvailabilityRequests[index],
                                          initializeData
                                            .jobAvailabilityRequests[index],
                                          day,
                                          false,
                                        );
                                      }
                                    } else {
                                      const newGroupByDayOfWeek = {
                                        ...groupByDayOfWeek,
                                      };
                                      if (event.target.checked) {
                                        if (newGroupByDayOfWeek[day]) {
                                          newGroupByDayOfWeek[day].status =
                                            "ACTIVE";
                                        } else {
                                          newGroupByDayOfWeek[day] = {
                                            status: "ACTIVE",
                                          };
                                        }
                                      } else {
                                        if (
                                          newGroupByDayOfWeek[day].id ||
                                          newGroupByDayOfWeek[day].id === 0
                                        ) {
                                          newGroupByDayOfWeek[day].status =
                                            "INACTIVE";
                                        } else {
                                          delete newGroupByDayOfWeek[day];
                                        }
                                      }
                                      setFieldValue(
                                        `jobAvailabilityRequests[${index}].groupByDayOfWeek`,
                                        newGroupByDayOfWeek,
                                      );
                                    }
                                  }
                                }}
                                name="daysOfWeek"
                              />
                            </div>
                          );
                        })}
                      </div>
                      {countDayOfWeekActive === 0 && (
                        <Label
                          className={`${classes.label}`}
                          style={{ color: AppColor.red, marginLeft: "5px" }}
                        >
                          {t("validation.requiredDayOfWeek")}
                        </Label>
                      )}
                      {isExpand && activeIds.length > 0 && jobId && (
                        <ShiftTasksSection
                          jobId={jobId}
                          activeAvailabilityIds={activeIds}
                          isDisabled={isDisabled}
                        />
                      )}
                      {isExpand && activeIds.length === 0 && (
                        <Box style={{ marginTop: "1rem", color: AppColor.greyDark, fontSize: "13px", fontStyle: "italic" }}>
                          {t("label.saveShiftFirst", "Please save this shift availability first to manage tasks.")}
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
        </React.Fragment>
      )}
    />
  );
};

JobAvailabilityFieldArray.propTypes = {
  jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setShowConfirmDeleteNextWeek: PropTypes.func,
  setJobAvailabilityDelete: PropTypes.func,
  getNumberDayOfWeek: PropTypes.func,
  setFieldValue: PropTypes.func,
  handleChange: PropTypes.func,
  formData: PropTypes.object,
  errors: PropTypes.object,
  // isAllowRemoveAvailability: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleCreateUpdateShift: PropTypes.func,
  handleShowPopupDeleteShift: PropTypes.func,
  handleChangeDayOfWeek: PropTypes.func,
  initializeData: PropTypes.object,
  isAdd: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
export default JobAvailabilityFieldArray;
